/**
 * @fileoverview Tools screen ("Studio Quiet"): a segmented Metronome / Tuner.
 * Reads the initial tab from the `initialTab` prop (used by the /metronome and
 * /tuner back-compat routes) or the `?tab=` query param (the /tools route).
 */

import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Eyebrow, SegmentedControl } from "@/components/studio/primitives";
import MetronomeTool from "@/components/studio/MetronomeTool";
import TunerTool from "@/components/studio/TunerTool";

const TABS = [
  { id: "metronome", label: "Metronome" },
  { id: "tuner", label: "Tuner" },
];

export default function ToolsPage({ initialTab }) {
  const [searchParams] = useSearchParams();
  const startTab = initialTab || searchParams.get("tab") || "metronome";
  const [tab, setTab] = useState(startTab === "tuner" ? "tuner" : "metronome");

  return (
    <div className="mx-auto max-w-[720px] px-6 pb-32 pt-11 md:px-12" data-testid="tools-page">
      <Eyebrow>Practice tools</Eyebrow>
      <h1 className="mb-7 mt-1.5 font-serif text-[40px] font-normal leading-none tracking-[-0.02em] text-[var(--text-primary)]">
        Tools
      </h1>

      <SegmentedControl block value={tab} onChange={setTab} options={TABS} className="mb-10" />

      {tab === "metronome" ? <MetronomeTool /> : <TunerTool />}
    </div>
  );
}
